













































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { ICompany, ICompanyType } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'company';
const ns = { namespace };

@Component
export default class CompanyDetail extends BaseDetail<ICompany> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, ICompany>;
  @State('entities', { namespace: 'companyType' }) companyTypes: ICompanyType[];
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
